import Component from '../core/Component'
import EventBus from '../core/EventBus'

export const STATES = {
    OPEN: 'is-opened'
}

export default class Dropdown extends Component {
    constructor(element) {
        super(element);

        this.ref = {
            button: null,
            dropdown: null,
        };

        this.hasError = false
        this.defaultLabel = ''
    }

    prepare() {
        this.defaultLabel = this.ref.button.textContent
        this.ref.button.addEventListener('click', this.handleToggleClick)
        this.element.addEventListener('change', this.handleChange)
        this.element.addEventListener('click', this.handleClick)
        document.addEventListener('click', this.handleOuterClick)

        // initial checked
        const checked = this.ref.dropdown.querySelector('input:checked');

        if (checked) {
            this.setLabel(checked.parentNode.textContent, checked)
        }
    }

    destroy() {
        document.removeEventListener('click', this.handleOuterClick);
    }

    handleClick = event => {
        const link = event.target.closest('a')
        const label = event.target.closest('label')

        if (link && label) {
            event.preventDefault()
            label.click()
        }
    }

    handleChange = event => {
        const target = event.target.closest('input[type="radio"]')

        if (target) {
            this.setLabel(target.parentNode.textContent, target)
            this.close()
        }
    }

    handleToggleClick = event => {
        event.preventDefault()
        this.toggle()
    }

    handleOuterClick = event => {
        if (!this.element.contains(event.target)) {
            this.close()
        }
    }

    addError(text) {
        setTimeout(() => {
            this.element.classList.add('has-error')
            this.open()
            this.ref.button.innerHTML = text;
        });

        this.hasError = true
    }

    removeError() {
        this.element.classList.remove('has-error')
        this.close()

        this.hasError = false
    }

    setLabel(text, srcInput = null) {
        this.ref.button.innerHTML = srcInput?.dataset.useDefaultLabel != undefined ? `<span>${this.defaultLabel}</span>` : `<span>${text}</span>`
    }

    toggle() {
        if (this.is(STATES.OPEN)) {
            this.close()
        } else {
            this.open()
        }
    }

    open() {
        if (this.is(STATES.OPEN)) {
            return
        }
        this.element.classList.add(STATES.OPEN)
    }

    close() {
        if (!this.is(STATES.OPEN)) {
            return
        }

        this.element.classList.remove(STATES.OPEN)
        EventBus.emit('overlay:close')
    }
}